<template>
  <div class="error">
    <div class="logo">
      <img src="@/assets/img/chiilih.svg" alt="">
    </div>
    <h1>{{ msg }}</h1>
    <p>抱歉！页面无法访问……</p>
    <router-link to="/" class="aas">回首页</router-link>

  </div>
</template>

<script>
import Navs from '@/components/nav'
export default {
  name: 'Error',
  components: {
    Navs
  },
  data() {
    return {
      msg: 'Error'
    }
  },
  destroyed: function() {
    console.log('我已经离开了！')
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.error {
  text-align: center;
  .logo {
    padding: 20%;
    img {
      width: 100%;
    }
  }
  h1,
  h2 {
    font-weight: normal;
    color: rgb(153, 69, 108);
    text-align: center;
    a {
      color: #fff;
      &.aas {
        background-color: rgb(190, 144, 144);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/error.vue